/* @ts-self-types="./index.d.ts" */

/**
 * This is a wrapper class that is wasm-bindgen compatible
 * We do not use js_name and rename it like CrateId because
 * then the impl block is not picked up in javascript.
 */
class CompilerContext {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CompilerContextFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_compilercontext_free(ptr, 0);
    }
    /**
     * @param {string} crate_name
     * @param {CrateId} from
     * @param {CrateId} to
     */
    add_dependency_edge(crate_name, from, to) {
        const ptr0 = passStringToWasm0(crate_name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(from, CrateId);
        _assertClass(to, CrateId);
        const ret = wasm.compilercontext_add_dependency_edge(this.__wbg_ptr, ptr0, len0, from.__wbg_ptr, to.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} _program_width
     * @returns {ContractCompileResult}
     */
    compile_contract(_program_width) {
        const ptr = this.__destroy_into_raw();
        const ret = wasm.compilercontext_compile_contract(ptr, _program_width);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {number} _program_width
     * @returns {ProgramCompileResult}
     */
    compile_program(_program_width) {
        const ptr = this.__destroy_into_raw();
        const ret = wasm.compilercontext_compile_program(ptr, _program_width);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {PathToFileSourceMap} source_map
     */
    constructor(source_map) {
        _assertClass(source_map, PathToFileSourceMap);
        var ptr0 = source_map.__destroy_into_raw();
        const ret = wasm.compilercontext_new(ptr0);
        this.__wbg_ptr = ret >>> 0;
        CompilerContextFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {string} path_to_crate
     * @returns {CrateId}
     */
    process_dependency_crate(path_to_crate) {
        const ptr0 = passStringToWasm0(path_to_crate, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.compilercontext_process_dependency_crate(this.__wbg_ptr, ptr0, len0);
        return CrateId.__wrap(ret);
    }
    /**
     * @param {string} path_to_crate
     * @returns {CrateId}
     */
    process_root_crate(path_to_crate) {
        const ptr0 = passStringToWasm0(path_to_crate, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.compilercontext_process_root_crate(this.__wbg_ptr, ptr0, len0);
        return CrateId.__wrap(ret);
    }
}
if (Symbol.dispose) CompilerContext.prototype[Symbol.dispose] = CompilerContext.prototype.free;
exports.CompilerContext = CompilerContext;

class CrateId {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CrateId.prototype);
        obj.__wbg_ptr = ptr;
        CrateIdFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CrateIdFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_crateid_free(ptr, 0);
    }
}
if (Symbol.dispose) CrateId.prototype[Symbol.dispose] = CrateId.prototype.free;
exports.CrateId = CrateId;

/**
 * This map contains the paths of all of the files in the entry-point crate and
 * the transitive dependencies of the entry-point crate.
 *
 * This is for all intents and purposes the file system that the compiler will use to resolve/compile
 * files in the crate being compiled and its dependencies.
 *
 * Using a `BTreeMap` to add files to the [FileManager] in a deterministic order,
 * which affects the `FileId` in the `Location`s in the AST on which the `hash` is based.
 * Note that we cannot expect to match the IDs assigned by the `FileManager` used by `nargo`,
 * because there the order is determined by the dependency graph as well as the file name.
 */
class PathToFileSourceMap {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PathToFileSourceMapFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_pathtofilesourcemap_free(ptr, 0);
    }
    /**
     * @param {string} path
     * @param {string} source_code
     * @returns {boolean}
     */
    add_source_code(path, source_code) {
        const ptr0 = passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(source_code, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.pathtofilesourcemap_add_source_code(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret !== 0;
    }
    constructor() {
        const ret = wasm.pathtofilesourcemap_new();
        this.__wbg_ptr = ret >>> 0;
        PathToFileSourceMapFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
}
if (Symbol.dispose) PathToFileSourceMap.prototype[Symbol.dispose] = PathToFileSourceMap.prototype.free;
exports.PathToFileSourceMap = PathToFileSourceMap;

/**
 * @returns {any}
 */
function build_info() {
    const ret = wasm.build_info();
    return ret;
}
exports.build_info = build_info;

/**
 * @param {string} entry_point
 * @param {DependencyGraph | null | undefined} dependency_graph
 * @param {PathToFileSourceMap} file_source_map
 * @returns {ContractCompileResult}
 */
function compile_contract(entry_point, dependency_graph, file_source_map) {
    const ptr0 = passStringToWasm0(entry_point, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    _assertClass(file_source_map, PathToFileSourceMap);
    var ptr1 = file_source_map.__destroy_into_raw();
    const ret = wasm.compile_contract(ptr0, len0, isLikeNone(dependency_graph) ? 0 : addToExternrefTable0(dependency_graph), ptr1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}
exports.compile_contract = compile_contract;

/**
 * This is a method that exposes the same API as `compile`
 * But uses the Context based APi internally
 * @param {string} entry_point
 * @param {DependencyGraph | null | undefined} dependency_graph
 * @param {PathToFileSourceMap} file_source_map
 * @returns {ContractCompileResult}
 */
function compile_contract_(entry_point, dependency_graph, file_source_map) {
    const ptr0 = passStringToWasm0(entry_point, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    _assertClass(file_source_map, PathToFileSourceMap);
    var ptr1 = file_source_map.__destroy_into_raw();
    const ret = wasm.compile_contract_(ptr0, len0, isLikeNone(dependency_graph) ? 0 : addToExternrefTable0(dependency_graph), ptr1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}
exports.compile_contract_ = compile_contract_;

/**
 * @param {string} entry_point
 * @param {DependencyGraph | null | undefined} dependency_graph
 * @param {PathToFileSourceMap} file_source_map
 * @returns {ProgramCompileResult}
 */
function compile_program(entry_point, dependency_graph, file_source_map) {
    const ptr0 = passStringToWasm0(entry_point, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    _assertClass(file_source_map, PathToFileSourceMap);
    var ptr1 = file_source_map.__destroy_into_raw();
    const ret = wasm.compile_program(ptr0, len0, isLikeNone(dependency_graph) ? 0 : addToExternrefTable0(dependency_graph), ptr1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}
exports.compile_program = compile_program;

/**
 * This is a method that exposes the same API as `compile`
 * But uses the Context based APi internally
 * @param {string} entry_point
 * @param {DependencyGraph | null | undefined} dependency_graph
 * @param {PathToFileSourceMap} file_source_map
 * @returns {ProgramCompileResult}
 */
function compile_program_(entry_point, dependency_graph, file_source_map) {
    const ptr0 = passStringToWasm0(entry_point, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    _assertClass(file_source_map, PathToFileSourceMap);
    var ptr1 = file_source_map.__destroy_into_raw();
    const ret = wasm.compile_program_(ptr0, len0, isLikeNone(dependency_graph) ? 0 : addToExternrefTable0(dependency_graph), ptr1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}
exports.compile_program_ = compile_program_;

/**
 * @param {string} level
 */
function init_log_level(level) {
    const ptr0 = passStringToWasm0(level, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    wasm.init_log_level(ptr0, len0);
}
exports.init_log_level = init_log_level;

function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg___wbindgen_debug_string_ddde1867f49c2442: function(arg0, arg1) {
            const ret = debugString(arg1);
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_is_undefined_c18285b9fc34cb7d: function(arg0) {
            const ret = arg0 === undefined;
            return ret;
        },
        __wbg___wbindgen_string_get_3e5751597f39a112: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof(obj) === 'string' ? obj : undefined;
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_throw_39bc967c0e5a9b58: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbg_constructor_57d0666c35307a69: function() {
            const ret = new Object();
            return ret;
        },
        __wbg_constructor_7fccf59883652975: function() {
            const ret = new Object();
            return ret;
        },
        __wbg_constructor_d03d6ea5a1d3b8f2: function(arg0) {
            const ret = new Error(arg0);
            return ret;
        },
        __wbg_debug_8804c16f548276da: function(arg0, arg1, arg2, arg3) {
            console.debug(arg0, arg1, arg2, arg3);
        },
        __wbg_debug_e69ad32e6af73f94: function(arg0) {
            console.debug(arg0);
        },
        __wbg_error_91d10625a3b36a08: function(arg0, arg1, arg2, arg3) {
            console.error(arg0, arg1, arg2, arg3);
        },
        __wbg_error_a6fa202b58aa1cd3: function(arg0, arg1) {
            let deferred0_0;
            let deferred0_1;
            try {
                deferred0_0 = arg0;
                deferred0_1 = arg1;
                console.error(getStringFromWasm0(arg0, arg1));
            } finally {
                wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
            }
        },
        __wbg_error_ad28debb48b5c6bb: function(arg0) {
            console.error(arg0);
        },
        __wbg_getTime_9429d05129287418: function(arg0) {
            const ret = arg0.getTime();
            return ret;
        },
        __wbg_info_28d530adaabdab8c: function(arg0, arg1, arg2, arg3) {
            console.info(arg0, arg1, arg2, arg3);
        },
        __wbg_info_72e7e65fa3fc8b25: function(arg0) {
            console.info(arg0);
        },
        __wbg_new_0_a719938e6f92ddf4: function() {
            const ret = new Date();
            return ret;
        },
        __wbg_new_227d7c05414eb861: function() {
            const ret = new Error();
            return ret;
        },
        __wbg_parse_6dfe891b5bafb5cd: function() { return handleError(function (arg0, arg1) {
            const ret = JSON.parse(getStringFromWasm0(arg0, arg1));
            return ret;
        }, arguments); },
        __wbg_set_bad5c505cc70b5f8: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = Reflect.set(arg0, arg1, arg2);
            return ret;
        }, arguments); },
        __wbg_stack_3b0d974bbf31e44f: function(arg0, arg1) {
            const ret = arg1.stack;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_stringify_86f4ab954f88f382: function() { return handleError(function (arg0) {
            const ret = JSON.stringify(arg0);
            return ret;
        }, arguments); },
        __wbg_warn_2540fe736f19ad5c: function(arg0, arg1, arg2, arg3) {
            console.warn(arg0, arg1, arg2, arg3);
        },
        __wbg_warn_3310c7343993c074: function(arg0) {
            console.warn(arg0);
        },
        __wbindgen_cast_0000000000000001: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = getStringFromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        },
    };
    return {
        __proto__: null,
        "./index_bg.js": import0,
    };
}

const CompilerContextFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_compilercontext_free(ptr >>> 0, 1));
const CrateIdFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_crateid_free(ptr >>> 0, 1));
const PathToFileSourceMapFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_pathtofilesourcemap_free(ptr >>> 0, 1));

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
function decodeText(ptr, len) {
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;

const wasmPath = `${__dirname}/index_bg.wasm`;
const wasmBytes = require('fs').readFileSync(wasmPath);
const wasmModule = new WebAssembly.Module(wasmBytes);
let wasm = new WebAssembly.Instance(wasmModule, __wbg_get_imports()).exports;
wasm.__wbindgen_start();
